import { Center, Stack } from "@chakra-ui/react";
import { LoginForm } from "./components";
import { LoginScreenDefinition } from "./Login.definition";
import { AuthFormContainer, AuthFormHeader } from "auth/components";
import { LogoBoxed } from "components";

const Login = () => {
  return (
    <AuthFormContainer>
      <Center>
        <Stack>
          <LogoBoxed w={"200px"} />
          <AuthFormHeader text={LoginScreenDefinition.name} />
        </Stack>
      </Center>
      <LoginForm />
    </AuthFormContainer>
  );
};

export { Login };
